module.exports = __webpack_public_path__ + "static/media/arrow_up_gray.71185cb0.svg";